export const BOOKMARK_COPY = {
  SAVE: 'Save',
  SAVING: 'Saving',
  SAVED: 'Saved',
  REMOVE_SAVE: 'Remove',
};
